import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import { ActionToast } from './ActionToast';
import { ActiveActionToast } from './ActionToastProvider';

const useStyles = makeStyles(theme => ({
  root: {
    position: 'fixed',
    top: theme.spacing(2),
    right: theme.spacing(2),
    zIndex: theme.zIndex.snackbar,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    pointerEvents: 'none',
  },
}));

export type ActionToastHostProps = {
  toasts: ActiveActionToast[];
  onDismiss: (id: string) => void;
};

// Fixed top-right stack, newest on top — deliberately not the same corner
// Backstage's own built-in toast uses (top-center by default), so the two
// systems never visually collide for a user who still sees both.
export const ActionToastHost = ({
  toasts,
  onDismiss,
}: ActionToastHostProps) => {
  const classes = useStyles();
  return (
    <Box className={classes.root}>
      {toasts.map(toast => (
        <Box key={toast.id} style={{ pointerEvents: 'auto' }}>
          <ActionToast
            kind={toast.kind}
            title={toast.title}
            description={toast.description}
            timeout={toast.timeout}
            onDismiss={() => onDismiss(toast.id)}
          />
        </Box>
      ))}
    </Box>
  );
};
